import { ChevronLeft } from 'lucide-react'
import { useOmpNav } from '../hooks/useOmpNav'

interface OmpDetailHeaderProps {
  to?: string
  title: string
}

// {back} {heading} row for the detail pages (Order/Subscription/Address/Payment).
const OmpDetailHeader = ({ to, title }: OmpDetailHeaderProps) => {
  const { goBack } = useOmpNav()
  return (
    <div className="omp-detail-head">
      <button type="button" className="omp-detail-back" aria-label="Back" data-omp-nav="" onClick={() => goBack(to)}>
        <ChevronLeft size={16} />
      </button>
      <h2 className="omp-page-title">{title}</h2>
    </div>
  )
}

export default OmpDetailHeader
